import * as React from "react";

export const CrossSVG = (props: any) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
        <g id="Group_5021" data-name="Group 5021" transform="translate(-290 -1083)">
            <circle id="Ellipse_181" data-name="Ellipse 181" cx="9" cy="9" r="9" transform="translate(290 1083)" fill="#dc3545" />
            <path
                id="_Color"
                data-name=" ↳Color"
                d="M9,.906,8.094,0,4.5,3.594.906,0,0,.906,3.594,4.5,0,8.094.906,9,4.5,5.406,8.094,9,9,8.094,5.406,4.5Z"
                transform="translate(294.5 1087.5)"
                fill="#fff"
            />
        </g>
    </svg>
);
